/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Mask(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/mask.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-0.03, 0.65, 0]} scale={1.41}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_4.geometry}
          material={materials['Material.002']}
        />
      </group>
      <group position={[-0.03, 0.65, 0]} scale={1.41}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_8.geometry}
          material={materials['Material.006']}
        >
          <meshStandardMaterial
            color="#006699"
            roughness={0.6}
            opacity={0.2}
            transparent={false}
          />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/mask.glb')
